import React from 'react';
import PropTypes from 'prop-types';
import FormValidator from '../../services/formValidation';
import i18n from '../../services/i18n';

/**
 * Simple form component to encapsulate jquery validation logic, passes a submitHandler function to
 * it's children to be used as a clickHandler on any chosen button
 *
 * Any undocumented prop will be passed along to the inner <form />
 */
export default class Form extends React.Component {
  componentDidMount() {
    FormValidator.config();
  }

  render() {
    const {
      id,
      validationRules,
      customMessages,
      submitMethod,
      onInvalidForm,
      children,
      tagInput,
      tagInputId,
      tagKeyHint,
      tagKeyError,
      ...rest
    } = this.props;

    const submitHandler = function submitForm(evt) {
      evt.preventDefault();

      const form = $(`#${id}`);
      const options = { rules: validationRules };
      if (customMessages) {
        options.messages = customMessages;
      }

      // JQuery Instructions to handle the error on keys length atLeast 1
      if (tagInputId) {
        const $tagsDivContainer = $(`#${tagInputId} .form-group`);
        const $tagsHint = $(`#${tagInputId} .m-form__help`);

        if ($tagsDivContainer) {
          if (!tagInput || tagInput?.length === 0) {
            $tagsDivContainer.addClass('has-danger');
            if ($tagsHint) {
              $tagsHint.text(i18n.__(tagKeyError));
              $tagsHint.addClass('has-danger');
            }
            $tagsDivContainer[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'start',
            });
            return;
          } else {
            $tagsDivContainer.removeClass('has-danger');
            if ($tagsHint) {
              $tagsHint.text(i18n.__(tagKeyHint));
              $tagsHint.removeClass('has-danger');
            }
          }
        }
      }

      form.validate(options);

      if (form.valid()) {
        submitMethod();
      } else if (onInvalidForm) {
        onInvalidForm();
      } else {
        const el = document.querySelector('.has-danger');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start',
          });
        }
      }
    };

    return (
      <form id={id} {...rest}>
        {children(submitHandler)}
      </form>
    );
  }
}

Form.propTypes = {
  /** Html form element id */
  id: PropTypes.string.isRequired,
  /** Validation rules as defined in the rules section of https://jqueryvalidation.org/validate/ */
  validationRules: PropTypes.shape({}).isRequired,
  customMessages: PropTypes.shape({}),
  /** Function to be called if the form is valid */
  submitMethod: PropTypes.func.isRequired,
  /** Function to be called if the form is invalid */
  onInvalidForm: PropTypes.func,
  /** The react child passed to the form is a function that receives a submitHandler that can be
   * passed as an onClick handler to a button */
  children: PropTypes.func.isRequired,
  tagInputId: PropTypes.string,
  tagInput: PropTypes.arrayOf(PropTypes.string),
  tagKeyHint: PropTypes.string,
  tagKeyError: PropTypes.string,
};

Form.defaultProps = {
  onInvalidForm: null,
  customMessages: null,
  tagInputId: null,
  tagInput: null,
  tagKeyHint: null,
  tagKeyError: null,
};
